import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import {
    Container,
    Row,
    Col,
    Button
} from "kepler";
import { parseMessages } from '../../utilityHelper';

const templateData = $('body').data();
const propertyInfo = parseMessages('directmodel/home');

export default class DirecModel extends React.Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        //Accordian
        $('.accordion').each(function () {
            var $accordian = $(this);
            $accordian.find('.accordion-head').on('click', function () {
                $(this).parent().find(".accordion-head").removeClass('openfaq closefaq');
                $(this).removeClass('openfaq').addClass('closefaq');
                $accordian.find('.accordion-body').slideUp();
                if (!$(this).next().is(':visible')) {
                    $(this).removeClass('closefaq').addClass('openfaq');
                    $(this).next().slideDown();
                }
            });
        });
    }
    render() {
        return (
            <div id="directModelWrapper" className="row">
                <Container className="container">
                <Row style={{'marginBottom':'30px'}}>
	                <Col><h1>{propertyInfo.directmodel.home.header}</h1></Col>
                </Row>
                <Row style={{'marginBottom':'40px'}}>
	                <Col><h2>{propertyInfo.directmodel.home.subheader}</h2></Col>
                </Row>
                <Row style={{'marginBottom':'40px'}}>
                    <Col basis="25%">
                        <p className="sectionHeader"><img src="https://www.paypalobjects.com/webstatic/ppgf/directmodel/charity.svg"/><img src="https://www.paypalobjects.com/webstatic/ppgf/directmodel/arrow.svg"/></p>
                        <p className="sectionTitle">{propertyInfo.directmodel.home.step1title}</p>
                        <p className="sectionBody">{propertyInfo.directmodel.home.step1desc}</p>
                    </Col>
                    <Col basis="25%">
                        <p className="sectionHeader"><img src="https://www.paypalobjects.com/webstatic/ppgf/directmodel/partners_1.svg"/><img src="https://www.paypalobjects.com/webstatic/ppgf/directmodel/arrow.svg"/></p>
                        <p className="sectionTitle">{propertyInfo.directmodel.home.step2title}</p>
                        <p className="sectionBody">{propertyInfo.directmodel.home.step2desc}</p>
                    </Col>
                    <Col basis="25%">
                        <p className="sectionHeader"><img src="https://www.paypalobjects.com/webstatic/ppgf/directmodel/resolution.svg"/><img src="https://www.paypalobjects.com/webstatic/ppgf/directmodel/arrow.svg"/></p>
                        <p className="sectionTitle">{propertyInfo.directmodel.home.step3title}</p>
                        <p className="sectionBody">{propertyInfo.directmodel.home.step3desc}</p>
                    </Col>
                    <Col basis="25%">
                        <p className="sectionHeader"><img src="https://www.paypalobjects.com/webstatic/ppgf/directmodel/donate.svg"/></p>
                        <p className="sectionTitle">{propertyInfo.directmodel.home.step4title}</p>
                        <p className="sectionBody">{propertyInfo.directmodel.home.step4desc}</p>
                    </Col>
                </Row>
                <Row style={{'marginBottom':'40px'}}>
                    <Col>
                        <Button href="/givingfund/enroll" className="enrollbtn">{propertyInfo.directmodel.home.enrollnow}</Button>
                    </Col>
                </Row>
                <Row style={{'marginBottom':'40px'}}>
                    <Col>
                        <p>{propertyInfo.directmodel.home.enrolldesc}</p>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h1 className="faq">{propertyInfo.directmodel.home.faqs} </h1>
                    </Col>
                </Row>
                <Row>
                    <Col>
                    <div className="accordion">
                        <div className="accordion-head">
                            <h4>{propertyInfo.directmodel.home.faq1}</h4><div className="arrow"></div>

                        </div>
                        <div className="accordion-body">
                            <p>{propertyInfo.directmodel.home.faq1ans}</p>
                        </div>
                        <div className="accordion-head">
                            <h4>{propertyInfo.directmodel.home.faq2}</h4><div className="arrow"></div>

                        </div>
                        <div className="accordion-body">
                            <p>{ ReactHtmlParser(propertyInfo.directmodel.home.faq2ans) }</p>
                        </div>
                        <div className="accordion-head">
                            <h4>{propertyInfo.directmodel.home.faq3}</h4><div className="arrow"></div>

                        </div>
                        <div className="accordion-body">
                            <p>{ ReactHtmlParser(propertyInfo.directmodel.home.faq3ans) }</p>
                        </div>
                        <div className="accordion-head">
                            <h4>{propertyInfo.directmodel.home.faq4}</h4><div className="arrow"></div>

                        </div>
                        <div className="accordion-body">
                            <p>{ ReactHtmlParser(propertyInfo.directmodel.home.faq4ans) }</p>
                        </div>
                        <div className="accordion-head">
                            <h4>{propertyInfo.directmodel.home.faq5}</h4><div className="arrow"></div>

                        </div>
                        <div className="accordion-body">
                            <p>{propertyInfo.directmodel.home.faq5ans}</p>
                        </div>
                        <div className="accordion-head">
                            <h4>{propertyInfo.directmodel.home.faq6}</h4><div className="arrow"></div>

                        </div>
                        <div className="accordion-body">
                            <p>{propertyInfo.directmodel.home.faq6ans}</p>
                        </div>
                        <div className="accordion-head">
                            <h4>{propertyInfo.directmodel.home.faq7}</h4><div className="arrow"></div>

                        </div>
                        <div className="accordion-body">
                            <p>{propertyInfo.directmodel.home.faq7ans}</p>
                        </div>
                        <div className="accordion-head">
                            <h4>{propertyInfo.directmodel.home.faq8}</h4><div className="arrow"></div>

                        </div>
                        <div className="accordion-body">
                            <p>{ ReactHtmlParser(propertyInfo.directmodel.home.faq8ans) }</p>
                        </div>
                        <div className="accordion-head">
                            <h4>{propertyInfo.directmodel.home.faq9}</h4><div className="arrow"></div>

                        </div>
                        <div className="accordion-body">
                            <p>{propertyInfo.directmodel.home.faq9ans}</p>
                        </div>
                        <div className="accordion-head">
                            <h4>{propertyInfo.directmodel.home.faq10}</h4><div className="arrow"></div>

                        </div>
                        <div className="accordion-body">
                            <p>{propertyInfo.directmodel.home.faq10ans}</p>
                        </div>
                        <div className="accordion-head">
                            <h4>{propertyInfo.directmodel.home.faq11}</h4><div className="arrow"></div>

                        </div>
                        <div className="accordion-body">
                            <p>{propertyInfo.directmodel.home.faq11ans}</p>
                        </div>
                    </div>
                    </Col>
                </Row>
                </Container>
            </div>
        );

    }
}


// WEBPACK FOOTER //
// ./directmodel/components/home.js